import _ from "lodash"
import React from "react"
import Lightbox from 'react-image-lightbox'
import ImagePlaceholder from "../../../../../components/ImagePlaceholder"

type ImagesProps = {
  images: Array<string>
}

type ImagesState = {
  isOpen: boolean
  photoIndex: number
}

class Images extends React.Component<ImagesProps, ImagesState> {
  constructor(props: ImagesProps) {
    super(props)
    this.state = {
      photoIndex: 0,
      isOpen: false,
    }
  };

  render() {
    const firstImage = _.first(this.props?.images || [])
    // const firstImage = 'https://images.unsplash.com/photo-1565739892345-f1d75c35d46b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80'
    const images = this.props?.images || []
    // const images = ['https://images.unsplash.com/photo-1565739892345-f1d75c35d46b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80']
    const {photoIndex, isOpen} = this.state
    return (
      <div>
        {firstImage ?
          <img alt="vehicle" src={firstImage || ''} onClick={() => {
            this.setState({isOpen: true})
          }}/>
          :
          <ImagePlaceholder/>
        }

        {isOpen && (
          <Lightbox mainSrc={images[photoIndex]} nextSrc={images[(photoIndex + 1) % images.length]} prevSrc={images[(photoIndex + images.length - 1) % images.length]} onCloseRequest={() => this.setState({isOpen: false})} onMovePrevRequest={() =>
            this.setState({
              photoIndex: (photoIndex + images.length - 1) % images.length,
            })
          } onMoveNextRequest={() =>
            this.setState({
              photoIndex: (photoIndex + 1) % images.length,
            })
          }/>
        )}
      </div>
    )
  }
}

export default Images
